import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ProviderSlotsRequest } from "@src/services/provider-slots.service";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the provider-slots endpoint.
 * Stringifies all numeric/array values to match the upstream API's expected format,
 * so the API route can forward req.body directly.
 */
export function buildProviderSlotsConfig(request: ProviderSlotsRequest): ApiCallConfig {
  const body: Record<string, string> = {
    user_uuid: request.userUuid,
    care_format: String(request.careFormat),
    practice_id: String(request.practiceId),
    provider_id: String(request.providerId),
    department_id: Array.isArray(request.departmentIds)
      ? request.departmentIds.join(",")
      : String(request.departmentIds),
    start_date: request.startDate,
    end_date: request.endDate,
    userLatitude: String(request.userLatitude),
    userLongitude: String(request.userLongitude),
  };

  if (request.minimum_day_time) {
    body.minimum_day_time = request.minimum_day_time;
  }

  if (request.clinicianType) {
    body.clinician_type = request.clinicianType;
  }

  if (request.duration !== undefined) {
    body.duration = String(request.duration);
  }

  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PROVIDER_SLOTS,
    body,
  };
}
